import { VmHaCluster } from 'api-client/model'
import { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { resmgrHostsSelector } from 'openstack/components/infrastructure/selectors'
import { getAggregatedUsage } from './helpers'
import { ClusterHostGroup, IClusterHostGroup } from './model'

export const clusterHostGroupsSelectorSimple: AppSelector<ClusterHostGroup[]> = createSharedSelector(
  getDataSelector<DataKeys.ClusterHostGroups>(DataKeys.ClusterHostGroups),
  (clusterHostGroups): ClusterHostGroup[] => {
    return clusterHostGroups.map((clusterHostGroup: ClusterHostGroup) => clusterHostGroup)
  },
)

export const clusterHostGroupsSelector: AppSelector<IClusterHostGroup[]> = createSharedSelector(
  getDataSelector<DataKeys.ClusterHostGroups>(DataKeys.ClusterHostGroups),
  getDataSelector<DataKeys.VmHaClusters>(DataKeys.VmHaClusters),
  resmgrHostsSelector,
  (clusterHostGroups, vmHaClusters, resmgrHosts): IClusterHostGroup[] => {
    return clusterHostGroups.map((clusterHostGroup: ClusterHostGroup) => {
      const hosts = resmgrHosts.filter((host) => clusterHostGroup?.hostlist?.includes(host.id))
      const physicalNetworkLabels = hosts?.[0]?.physicalNetworkLabels || []
      const resMgr =
        clusterHostGroup?.vmHighAvailability || ({} as ClusterHostGroup['vmHighAvailability'])
      const haMgr =
        vmHaClusters?.find((vmHaCluster) => vmHaCluster?.name === clusterHostGroup.name) ||
        ({} as VmHaCluster)

      const vmHaState = (() => {
        if (!resMgr?.enabled) {
          return 'disabled'
        }

        if (resMgr?.enabled && hosts?.length < 2) {
          return 'waiting'
        }

        if (resMgr?.enabled && haMgr?.enabled && haMgr?.task_state === 'completed') {
          return 'active'
        }

        if (
          (resMgr?.enabled && haMgr?.enabled && haMgr?.task_state !== 'completed') ||
          (resMgr?.enabled && !haMgr?.enabled)
        ) {
          return haMgr?.task_state || 'pending'
        }

        return 'disabled'
      })()

      return {
        ...clusterHostGroup,
        hosts,
        totalUsage: getAggregatedUsage(hosts),
        physicalNetworkLabels,
        vmHaState,
      }
    })
  },
)
